import { useEffect, useState } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import Admin from "@/pages/Admin";
import MyBookings from "@/pages/MyBookings";
import { AuthProvider } from "@/lib/auth";
import { AuthCallback } from "@/components/site/AuthCallback";

function AppRouter({ dark, toggleTheme }) {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<Home dark={dark} toggleTheme={toggleTheme} />} />
      <Route path="/admin" element={<Admin />} />
      <Route path="/my-bookings" element={<MyBookings />} />
    </Routes>
  );
}

function App() {
  const [dark, setDark] = useState(() => localStorage.getItem("vsi_theme") === "dark");

  useEffect(() => {
    document.documentElement.classList.toggle("dark", dark);
    localStorage.setItem("vsi_theme", dark ? "dark" : "light");
  }, [dark]);

  const toggleTheme = () => setDark((d) => !d);

  return (
    <div className="App">
      <Toaster position="top-right" richColors />
      <BrowserRouter>
        <AuthProvider>
          <AppRouter dark={dark} toggleTheme={toggleTheme} />
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
